import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ticketmaster = defineConnector({
  identifier: "ticketmaster",
  name: "Ticketmaster",
  tagLine: "Event discovery API",
  keywords: "tickets, events, concerts, venues, resale, discovery",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://app\\.ticketmaster\\.com/discovery/v2/.*",
  auth: (app) => queryAuth([{ name: "apikey", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to the [Ticketmaster Developer Portal](https://developer-account.ticketmaster.com/user/login), or [register](https://developer-account.ticketmaster.com/user/register) if you don’t have an account, and copy the API key for your app.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://app.ticketmaster.com/discovery/v2/events.json?size=1",
      expectedStatus: 200,
    }),
  },
  usageHint: () =>
    "Ticketmaster Discovery API v2 at https://app.ticketmaster.com/discovery/v2/ (for example events.json, attractions.json, venues.json). Add source=tmr to limit results to Ticketmaster Resale. The default quota is 5,000 calls per day and 5 requests per second, and deep paging stops at the 1,000th item.",
});
